import PagesFooter from '../../components/PagesFooter/PagesFooter';
import PagesHeader from '../../components/PagesHeader/PagesHeader';
import RadioField from '../../components/RadioField/RadioField';
import Title from '../../components/Title/Title';
import { usePagesContext } from '../../context/PagesContext';
import { scrollToFieldWithError } from '../../helpers/scrollToFieldWithError';
import { useAppDispatch } from '../../hooks';
import useComponentTracker from '../../hooks/useComponentTracker';
import useDefaultPagesAction from '../../hooks/useDefaultPagesAction';
import usePagesConfig from '../../hooks/usePagesConfig';
import useSetBannerType from '../../hooks/useSetBannerType';
import useTranslation from '../../hooks/useTranslation';
import useValidation from '../../hooks/useValidation';
import { addOrUpdateFormField } from '../../store/applicationform';
import { WizardPageAction } from '../../store/wizard/wizard';

const CreditCardPage = () => {
    useComponentTracker('CreditCardPage');
    const dispatch = useAppDispatch();
    const translate = useTranslation();
    const defaultPagesAction = useDefaultPagesAction();
    const { totalSections, totalAboutYouPages } = usePagesConfig();
    const { currentPage } = usePagesContext();
    useSetBannerType('bannerOne');
    const validationErrors = useValidation(['applicantDankort']);

    const onAction = async (action: WizardPageAction) => {
        if (action === 'next' && validationErrors.length) {
            scrollToFieldWithError(validationErrors);
            validationErrors.forEach((validationError) => {
                dispatch(addOrUpdateFormField(validationError));
            });
            return false;
        }

        return defaultPagesAction(action);
    };

    return (
        <>
            <PagesHeader
                actions={['back']}
                onAction={onAction}
                currentPage={currentPage}
                currentSection={0}
                numberOfSections={totalSections}
                numberOfPagesInSection={totalAboutYouPages}
                currentPageInSection={currentPage}
                sectionTitle={translate('field.section.about-you')}
            />
            <Title text={translate('page.credit-card.title')} />
            <RadioField
                name="applicantDankort"
                options={[
                    { id: 'true', label: translate('field.dankort-toggle.option.yes.label') },
                    { id: 'false', label: translate('field.dankort-toggle.option.no.label') },
                ]}
            />
            <PagesFooter
                actions={['next']}
                onAction={onAction}
                currentSection={0}
                numberOfSections={totalSections}
                numberOfPagesInSection={totalAboutYouPages}
                currentPageInSection={currentPage}
                sectionTitle={translate('field.section.about-you')}
            />
        </>
    );
};

export default CreditCardPage;
